import { Controller } from '@hotwired/stimulus'
import { isDismissed, rememberDismissal } from '../utils'

const COOKIE = 'app_banner_dismissed'

// Connects to data-controller="app-banner"
// Android "install the app" bar, at the very top of the page. The mobile top bar is
// fixed: --app-banner-offset keeps it under the bar until the bar has scrolled away.
// The cross sets the cookie that stops the server from rendering it again
// (ApplicationHelper#android_app_banner?).
export default class extends Controller {
  connect() {
    // A page restored from the Turbo cache can still hold the bar after it was closed.
    if (isDismissed(COOKIE)) {
      this.element.remove()
      return
    }

    this.update()
    window.addEventListener('scroll', this.update, { passive: true })
    window.addEventListener('resize', this.update, { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.update)
    window.removeEventListener('resize', this.update)
    document.documentElement.style.removeProperty('--app-banner-offset')
  }

  close() {
    rememberDismissal(COOKIE)
    this.element.remove()
  }

  // Setting a property on <html> restyles the whole page: only when the offset changes, so
  // not any more once the bar has scrolled away.
  update = () => {
    const offset = Math.max(0, this.element.offsetHeight - window.scrollY)
    if (offset === this.offset) return

    this.offset = offset
    document.documentElement.style.setProperty('--app-banner-offset', `${offset}px`)
  }
}
